export default { sha: '928d02b8f79976c2f067c3cdd775eb8cf8bc18c3', buildNumber: 'undefined' }
